import { Modal, Grid, Box, Typography } from "@mui/material"
import { PieChart } from "@mui/x-charts"
import { studentData } from "../../../../context/studentContext"

export type PieChartData = {
    id: string,
    label: string,
    value: number
}
export type PendingConsentDataType = {
    location: string,
    students: studentData[]
}

const PendingStudentsModal = ({ students, openPendingModal, handleClosePendingModal }: { students: studentData[], openPendingModal: boolean, handleClosePendingModal: () => void }) => {
    const pendingConsentData: PendingConsentDataType[] = [];

    students.forEach((student: any) => {
        const location = student.location.name ?? "Unknown";

        let group = pendingConsentData.find(
            (item) => item.location === location
        );

        if (!group) {
            group = {
                location,
                students: [],
            };

            pendingConsentData.push(group);
        }

        group.students.push(student);
    });
    const pieChartData: PieChartData[] = pendingConsentData.map(
        (item, index) => ({
            id: index.toString(),
            label: item.location,
            value: item.students.length,
        })
    );
    return (
        <Modal open={openPendingModal} onClose={handleClosePendingModal}>
            <Box component="div" sx={{
                position: "absolute" as "absolute",
                top: "50%",
                left: "50%",
                borderRadius: "10px",
                transform: "translate(-50%, -50%)",
                width: 800,
                // maxHeight: "90vh",
                // overflowY: "auto",
                bgcolor: "background.paper",
                border: "2px solid #000",
                boxShadow: 24,
                padding: "24px",
            }}>
                <Grid container spacing={2}>
                    <Grid size={12} textAlign="center">
                        <Typography variant="h5">Pending Consent</Typography>
                    </Grid>
                    <Grid size={12}>
                        <Grid container sx={{ display: "flex", justifyContent: "center" }}>
                            <Grid size={12}>
                                <Box sx={{ width: "100%", height: 300 }}>
                                    <PieChart
                                        sx={{
                                            "& .MuiChartsLegend-root": {
                                                maxWidth: "auto", maxHeight: "auto"
                                            },
                                            "& .MuiChartsLegend-root text": {
                                                fontSize: 12,
                                            },
                                        }}

                                        slotProps={{
                                            legend: {
                                                direction: "vertical",
                                            },
                                        }}
                                        // width="100%"
                                        height={300}
                                        series={[
                                            {
                                                data: pieChartData ?? [],
                                                outerRadius: 140,
                                            },
                                        ]} />

                                </Box>

                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid size={12} sx={{
                        maxHeight: 300,
                        overflowY: "auto",
                        overflowX: "hidden",
                    }}>
                        <Grid container spacing={2}>
                            {pendingConsentData.map((location, index) => (
                                <Grid size={6} key={`${location}-${index}`}>
                                    <Typography>{location.location}</Typography>
                                    <ul>
                                        {location.students.map((student) => (
                                            <li>{student.firstName} {student.lastName}: {student.parentalConsentStatus != null ? "Pending" : "Not Requested"}</li>
                                        ))}
                                    </ul>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>

                </Grid >
            </Box>
        </Modal >
    )
}
export default PendingStudentsModal